module.exports = __webpack_public_path__ + "static/media/nus.c18e72f2.png";